var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb"},[_c('el-breadcrumb',{attrs:{"separator":"/"}},_vm._l((_vm.list),function(item){return _c('el-breadcrumb-item',{key:item.path,attrs:{"to":item.path}},[_vm._v(_vm._s(item.meta.label))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }